import React, {memo} from 'react';
import UserAvatar from "./UserAvatar";

const AccountItem = memo(({account, company}) => {
    return (
        <div className="sl-flex sl-avatar-label-group sl-justify-start sl-align-center">
            <UserAvatar userData={account} isAvatarActive={false}
                        avatarClass="sl-h-8 sl-w-8 sl-inline-flex"/>

            <div
                className="sl-flex sl-flex-col">
                <div className={"sl-flex sl-flex-row"}>
                                            <span
                                                className="sl-font sl-text-md sl-font-medium sl-text-gray-900 sl-mr-1">
                                            {account.first_name} {account.last_name}</span>
                    {account.is_primary &&
                        <div
                            className="sl-badge sl-badge-sm sl-badge-gray sl-rounded-2xl sl-text-gray-500 sl-font sl-text-xs sl-font-normal">
                            Primary Contact</div>}
                </div>
                <span
                    className={"sl-text-gray-500 sl-font sl-text-sm sl-font-normal"}>{company.name}</span>
            </div>
        </div>
    );
});

export default AccountItem;
